import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  distanceUnitField,
  flightRouteField,
  passengerQuantityField,
  tripKindField,
} from './common/travelFields';

export const travelAirMetadata = {
  displayName: msg({
    message: 'Commercial air travel',
    context: 'Activity data schema name for commercial air travel',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    distance_quantity: {
      displayName: msg({
        message: 'Per-passenger distance',
        context:
          'The display name for a dimension. Sometimes we ask for distance for a single trip as well as a passenger count, and in that case the distance refers to the distance that a single passenger traveled.',
      }),
    },
    distance_unit: distanceUnitField,
    exclude_radiative_forcing: {
      displayName: msg({
        message: 'Exclude radiative forcing',
        context:
          'Whether to exclude radiative forcing from carbon calculation.',
      }),
      externalDescription: msg({
        message:
          'Whether to exclude radiative forcing from carbon calculation.',
        context: 'Exclude radiative forcing',
      }),
    },
    flight_cabin_class: {
      displayName: msg({
        message: 'Flight cabin class',
        context: 'A list of cabin classes.',
      }),
      externalDescription: msg({
        message: 'A list of cabin classes.',
        context: 'Flight cabin class',
      }),
    },
    flight_route: flightRouteField,
    passenger_quantity: passengerQuantityField,
    trip_kind: tripKindField,
  },
} as const satisfies BatMetadataConfigEntry;
